/* eslint-disable jsx-a11y/anchor-is-valid */
import { useNavigate, useParams } from "react-router-dom";
import { RoutedModal } from "../../../components/common";
import { pathConstants } from "../../../routes/pathContants";
import secondaryComponents from "../../../components/secondaryComponents";
import globalStyles from "../../../assets/styles/base/globalPage.module.scss";
import { useSMStoreTerminal } from "./useSMStoreTerminal";
import { StoreAssignedTerminals } from "../../../components/secondaryComponents/IntegratedTerminals";
import { capitalizeFirstLetterOfEachWords } from "../../../helpers";

export const SMStoreTerminal = () => {
  const navigate = useNavigate();
  const { store_id } = useParams();
  const {
    search,
    isLoading,
    terminals,
    integratedPaymentProviders,
    filterByKey,
  } = useSMStoreTerminal({});

  return (
    <RoutedModal
      isActive={true}
      headerTitle="Assign Terminal To Device"
      headerDescription="Record products returned by your customers."
      closeModal={() =>
        navigate(pathConstants.SELL_MODE({ store_id: store_id }))
      }
    >
      {integratedPaymentProviders?.length > 0 ? (
        <div className={globalStyles.rowNavigations}>
          {integratedPaymentProviders?.map((provider) => (
            <a
              key={provider}
              className={`${globalStyles.rowNavigations__item} ${
                search.get("terminal_type") === provider
                  ? globalStyles.active
                  : ""
              }`}
              onClick={() => filterByKey("terminal_type", provider)}
            >
              {capitalizeFirstLetterOfEachWords(provider)}
            </a>
          ))}
        </div>
      ) : null}

      <secondaryComponents.LoaderHelper isLoading={isLoading} classNames="mt-5">
        <div className={`${globalStyles.cardWithBorder} p-0`}>
          <StoreAssignedTerminals deviceList={terminals} />
        </div>
      </secondaryComponents.LoaderHelper>
    </RoutedModal>
  );
};
